/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { WebAppMinStationDto } from "./WebAppMinStationDto";

export const WebAppStationGroupDtoAccessTypeEnum = {
    OWNED: "OWNED",
    SHARED: "SHARED"
} as const;

export type WebAppStationGroupDtoAccessTypeEnumKey = (typeof WebAppStationGroupDtoAccessTypeEnum)[keyof typeof WebAppStationGroupDtoAccessTypeEnum];

export type WebAppStationGroupDto = {
    /**
     * @description Station group unique identifier
     * @type string
    */
    id: string;
    /**
     * @description Station group name
     * @type string
    */
    name: string;
    /**
     * @description Station group URL slug
     * @type string
    */
    slug: string;
    /**
     * @description Stations in the group
     * @type array | undefined
    */
    stations?: WebAppMinStationDto[];
    /**
     * @description Access relation for the requesting client: OWNED, SHARED, or null when not scoped
     * @type string
    */
    accessType?: WebAppStationGroupDtoAccessTypeEnumKey | null;
};